<template>
  <div>
    <el-container>
      <el-header>
        <h2>Tracking</h2>
      </el-header>
      <el-main>
        <el-form class="actions search-bar" :inline="true" >
          <el-form-item label="Date" >
            <el-date-picker
               v-model="date"
               @change="updateFilters"
               type="datetimerange"
               range-separator="à"
               start-placeholder="Date de début"
               end-placeholder="Date de fin" />
          </el-form-item>
          <el-form-item label="Action" >
            <el-input v-model="action" @change="updateFilters" />
          </el-form-item>
          <el-form-item label="IP" >
            <el-input v-model="ip" @change="updateFilters" />
          </el-form-item>
          <el-form-item label="UID" >
            <el-input v-model="uid" @change="updateFilters" />
          </el-form-item>
          <el-form-item label="Empreinte" >
            <el-input v-model="fingerprint" @change="updateFilters" />
          </el-form-item>

          <el-form-item>
            <el-button
               type="primary"
               icon="el-icon-fa-download"
               :circle="true"
               @click="e => initExport()" />
          </el-form-item>
        </el-form>

        <el-table :data="trackings" @row-click="handleRowClick" >
          <el-table-column prop="date" label="Date" />
          <el-table-column prop="action" label="Action" />
          <el-table-column prop="url" label="URL" />
          <el-table-column prop="identity.ip" label="IP" />
          <el-table-column prop="identity.uid" label="UID" />
          <el-table-column prop="identity.fingerprint" label="Empreinte" />
        </el-table>
        <el-pagination
           layout="prev, pager, next"
           :total="total"
           :background="true"
           :page-size="limit"
           @current-change="handlePageChange" />
      </el-main>
    </el-container>
    <el-dialog title="Data" :visible.sync="showDataDialog" >
      <pre>{{ currentData }}</pre>
    </el-dialog>
    <el-dialog title="Export" :visible.sync="showExportDialog" >
      <el-form>
        <el-form-item label="Titre" >
          <el-input v-model="exportName" />
        </el-form-item>
        <el-form-item label="Format" >
          <el-select v-model="exportFormat" >
            <el-option label="csv" value="csv" />
            <el-option label="json" value="json" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="showExportDialog = false">Annuler</el-button>
        <el-button type="primary" @click="e => handleExport()">Exporter</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {api} from 'macarons'
import moment from 'moment'

export default {
  data () {
    return {
      date: null,
      start: null,
      stop: null,
      action: null,
      ip: null,
      uid: null,
      fingerprint: null,
      trackings: [],
      total: 0,
      offset: 0,
      limit: 10,
      current: null,
      showDataDialog: false,
      showExportDialog: false,
      exportName: null,
      exportFormat: 'csv'
    }
  },
  mounted () {
    this.updateData()
  },
  computed: {
    currentData () {
      if (!this.current) {
        return null
      }
      return JSON.stringify(JSON.parse(this.current.data), null, 4)
    },
    filters () {
      const filters = [{
        type: 'App\\Model\\Filter\\GreaterThanOrEqualsFilter',
        field: 'hostname',
        value: JSON.stringify(window.location.host)
      }]
      if (this.date) {
        filters.push({
          type: 'App\\Model\\Filter\\GreaterThanOrEqualsFilter',
          field: 'date',
          value: JSON.stringify(this.date[0].toISOString())
        })
        filters.push({
          type: 'App\\Model\\Filter\\LowerThanOrEqualsFilter',
          field: 'date',
          value: JSON.stringify(this.date[1].toISOString())
        })
      }
      if (this.action) {
        filters.push({
          type: 'App\\Model\\Filter\\EqualsFilter',
          field: 'action',
          value: JSON.stringify(this.action)
        })
      }
      if (this.ip) {
        filters.push({
          type: 'App\\Model\\Filter\\EqualsFilter',
          field: 'identity.ip',
          value: JSON.stringify(this.ip)
        })
      }
      if (this.uid) {
        filters.push({
          type: 'App\\Model\\Filter\\EqualsFilter',
          field: 'identity.uid',
          value: JSON.stringify(this.uid)
        })
      }
      if (this.fingerprint) {
        filters.push({
          type: 'App\\Model\\Filter\\EqualsFilter',
          field: 'identity.fingerprint',
          value: JSON.stringify(this.fingerprint)
        })
      }
      return filters
    }
  },
  methods: {
    updateFilters () {
      this.offset = 0
      this.updateData()
    },
    updateData () {
      api.post('proxy/tracking', {
        offset: this.offset,
        limit: this.limit,
        orders: [ { direction: 'DESC', column: 'date' } ],
        filters: this.filters
      }).then(({data}) => {
        this.trackings.splice(0, this.trackings.length, ...data.results)
        this.total = data.count
      })
    },
    handlePageChange (page) {
      this.offset = (page - 1) * this.limit
      this.updateData()
    },
    handleRowClick (row) {
      this.current = row
      if (this.currentData) {
        this.showDataDialog = true
      }
    },
    initExport () {
      this.exportName = `Export Tracking ${moment().format('lll')}`.replace(' ', '_')
      this.showExportDialog = true
    },
    handleExport () {
      api.post('proxy/tracking-export', {
        name: this.exportName,
        format: this.exportFormat,
        filters: this.filters
      }).then(() => {
        this.$message(`Votre export "${this.exportName}" est en cours de traitement.`)
        this.showExportDialog = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/tracking/components/Tracking.vue